import React, { useState } from 'react';
import { ChevronDown, ChevronUp, HelpCircle } from 'lucide-react';
const FAQS = [{
  question: '¿Qué recibo al comprar el Kit?',
  answer: 'Recibís acceso inmediato a una plataforma digital donde podrás descargar todo el material: planificaciones, clases paso a paso, actividades, evaluaciones, rúbricas y todos los bonos mencionados. Todo en formato editable y PDF listo para imprimir.'
}, {
  question: '¿Cuándo me llega?',
  answer: 'El acceso es automático e inmediato. En cuanto se acredita tu pago (que suele ser instantáneo), recibís un correo electrónico con tus datos de acceso para ingresar a la plataforma y descargar todo el material.'
}, {
  question: '¿Cómo lo recibo? ¿Es físico o digital?',
  answer: 'Es 100% digital. No enviamos nada por correo postal. Esto te permite tener el material al instante en tu computadora, tablet o celular y usarlo cuando quieras, sin esperar envíos.'
}, {
  question: '¿Necesito ser profesional?',
  answer: 'El material está diseñado para docentes de nivel secundario, pero está explicado con tanta claridad que cualquier persona que necesite enseñar estos temas puede utilizarlo. Es ideal tanto para docentes experimentados como para quienes recién inician.'
}, {
  question: '¿Tengo acceso para siempre?',
  answer: '¡Sí! El acceso es vitalicio. Una vez que comprás, el material es tuyo para siempre. Podés descargarlo las veces que quieras y usarlo todos los años.'
}, {
  question: '¿Qué hago si no me llega el acceso?',
  answer: 'Si no ves el correo en tu bandeja de entrada, revisá la carpeta de Spam o Promociones. Si aún así no lo encontrás, podés escribirnos a nuestro soporte y te lo reenviamos en el acto.'
}, {
  question: '¿Es una compra segura?',
  answer: 'Totalmente. Utilizamos Hotmart, la plataforma de productos digitales más grande y segura de Latinoamérica. Tus datos están encriptados y protegidos. Nosotros no tenemos acceso a los datos de tu tarjeta.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="py-20 bg-gray-50" data-id="element-31">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-32">
        <div className="text-center mb-12" data-id="element-33">
          <HelpCircle className="w-12 h-12 text-blue-600 mx-auto mb-4" data-id="element-34" />
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-35">
            Resolvé aquí tus DUDAS
          </h2>
          <p className="text-xl text-gray-600" data-id="element-36">
            Las preguntas más frecuentes sobre el pack
          </p>
        </div>

        <div className="space-y-4" data-id="element-37">
          {FAQS.map((faq, index) => <div key={index} className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden transition-all duration-200 hover:shadow-md" data-id="element-38">
              <button onClick={() => toggleFAQ(index)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" aria-expanded={openIndex === index} data-id="element-39">
                <span className="font-bold text-gray-900 text-lg" data-id="element-40">
                  {faq.question}
                </span>
                {openIndex === index ? <ChevronUp className="w-6 h-6 text-blue-600 flex-shrink-0 ml-4" data-id="element-41" /> : <ChevronDown className="w-6 h-6 text-gray-400 flex-shrink-0 ml-4" data-id="element-42" />}
              </button>

              <div className={`px-6 text-gray-600 leading-relaxed overflow-hidden transition-all duration-300 ease-in-out ${openIndex === index ? 'max-h-96 pb-5 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-43">
                <div className="pt-2 border-t border-gray-100" data-id="element-44">
                  {faq.answer}
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}